<template>
  <div class="customize-store">
    <v-row>
      <!-- <v-col cols="12" md="12" sm="12" class="text-center"> -->
      <!-- <h2>Import content from one of your existing stores</h2> -->
      <!-- <p class="mt-5">
          <v-icon>fas fa-lightbulb</v-icon>
          Final step: change the whole Look and Feel of your store with these simple settings. Make it uniquely yours!
        </p>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <span class=""> Primary color </span>
            <v-menu offset-y v-model="showMenu">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex input-picker-color">
                  <v-text-field
                    class="my-0 text-field-color"
                    v-model="primaryColor"
                    v-bind="attrs"
                    v-on="on"
                    @click="showMenu = true"
                    hide-details
                  ></v-text-field>
                  <div class="p-3 btn-color">
                    <v-btn
                      :style="{ backgroundColor: primaryColor }"
                      class="px-0"
                      width="20"
                      min-width="20"
                      height="20"
                      min-height="20"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    ></v-btn>
                  </div>
                </div>
              </template>
              <v-color-picker class="ma-2" v-model="primaryColor" :swatches="swatches" show-swatches></v-color-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <span class=""> Font </span>
            <v-autocomplete
              @change="selectFont"
              :items="fonts"
              v-model="font"
              :error-messages="invalid && !$v.font.required ? $t('Font is required') : ''"
              class="my-0"
              item-text="family"
              item-value="family"
              auto-select-first
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" sm="12" class="d-flex mb-3">
            <v-btn @click="$parent.$parent.$parent.e1 = 3">Back</v-btn>
            <v-btn class="ml-auto" :loading="isLoading" @click="submit" color="primary">Take me to my store!</v-btn>
          </v-col>
        </v-row> -->
      <!-- </v-col> -->
      <!-- <v-col cols="12" md="12" sm="12" class="text-center">
        <v-select
          :items="stores"
          item-text="name"
          item-value="id"
          placeholder="Select store"
          v-model="importFromStore.storeId"
        ></v-select>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="" v-if="importFromStore.storeId">
        <h3>Select which contents you want to import</h3>

        <div>You can import contents that you have permission of the selected store.</div>
      </v-col> -->
      <!-- <template v-if="importFromStore.storeId">
        <v-col v-for="(check, k) in importFromStore.importItems" :key="check + k" cols="12" md="6" sm="6">
          <v-checkbox
            hide-details
            :label="`${k.substr(0, k.search(`Checked`))}`"
            v-model="importFromStore.importItems[k]"
          ></v-checkbox>
        </v-col>
      </template> -->
      <!-- <v-col class="d-none d-sm-flex" cols="12" md="6" sm="12">
        <div class="iphone">
          <div class="power"></div>
          <div class="lock"></div>
          <div class="volume up"></div>
          <div class="volume down"></div>
          <div class="camera"></div>
          <div class="speaker"></div>
          <div class="screen">
            <iframe
              v-if="store"
              width="100%"
              height="100%"
              :src="'https://' + store.storeDetail.defaultSystemDomain + '?cache=noCacheLattehub'"
              frameborder="0"
              allowfullscreen
              title="Theme demo"
            ></iframe>
          </div>
          <div class="button">
            <div class="square"></div>
          </div>
        </div>
      </v-col> -->
    </v-row>

    <!-- Terms of Service Section -->
    <v-row>
      <v-col cols="12">
        <div class="terms-scroll-container">
          <v-card class="pa-6">
            <div class="text-center mb-6">
              <h1 style="font-weight: 700; font-size: 32px;">
                Điều khoản sử dụng
              </h1>
            </div>

            <div class="terms-content">
              <p class="mb-4">
                Chào mừng bạn đến với trang web Dropnoxe.com và/hoặc ứng dụng DROPNOXE. Vui lòng đọc kỹ các Điều khoản
                sử dụng này. Các Điều khoản sử dụng sau đây điều chỉnh việc bạn sử dụng và truy cập Nền tảng DROPNOXE
                (như được nêu ở phần sau) và việc sử dụng bất kỳ phần nào của Dịch vụ (như được nêu ở phần sau).
              </p>

              <p class="mb-4">
                Bằng cách
                <strong>đăng ký tạo tài khoản, truy cập Nền tảng DROPNOXE</strong> và/hoặc
                <strong>sử dụng Dịch vụ,</strong> bạn đồng ý rằng, bạn đã đọc và hiểu các điều khoản trong Điều khoản sử
                dụng này và chịu ràng buộc bởi các Điều khoản sử dụng này, tạo thành một thỏa thuận ràng buộc về mặt
                pháp lý giữa bạn và DROPNOXE (như được nêu ở phần sau).
                <strong
                  >Nếu bạn không đồng ý với các Điều khoản sử dụng này, vui lòng không truy cập và/hoặc sử dụng Nền tảng
                  DROPNOXE này cũng như bất kỳ phần nào của Dịch vụ.</strong
                >
              </p>

              <v-alert color="warning" outlined class="mb-4">
                <strong>Lưu ý:</strong> DROPNOXE có quyền sửa đổi, bổ sung hoặc bãi bỏ bất kỳ nội dung nào được nêu
                trong Điều khoản sử dụng này theo thời gian bằng cách thông báo cho bạn thông qua việc công bố phiên bản
                cập nhật của Điều khoản sử dụng này trên Nền tảng DROPNOXE hoặc gửi thông báo đến email đã đăng ký của
                bạn hoặc bằng cách gửi thông báo trên trên ứng dụng điện tử DROPNOXE ít nhất 7 (bảy) ngày trước khi các
                thay đổi có hiệu lực ("Thời hạn thông báo"). Trong trường hợp bạn không đồng ý với những thay đổi đó,
                vui lòng không tiếp tục truy cập Nền tảng DROPNOXE hoặc chấm dứt việc sử dụng bất kỳ phần nào của Dịch
                vụ. Bạn đồng ý rằng bạn có trách nhiệm thường xuyên xem xét và cân nhắc nội dung cập nhật của Điều khoản
                sử dụng. Việc bạn tiếp tục truy cập Nền tảng DROPNOXE hoặc tiếp tục sử dụng Dịch vụ sau Thời hạn thông
                báo có nghĩa là bạn thừa nhận và đồng ý với nội dung cập nhật của Điều khoản sử dụng kể từ ngày có hiệu
                lực của các bản cập nhật này.
              </v-alert>

              <p class="mb-4">
                Việc truy cập và sử dụng chức năng được bảo vệ bằng mật khẩu và/hoặc bảo mật của Nền tảng DROPNOXE
                và/hoặc việc sử dụng Dịch vụ bị hạn chế đối với Khách hàng có Tài khoản người dùng DROPNOXE (như được
                định nghĩa bên dưới) và bạn phải đủ từ 18 tuổi trở lên. Bạn không được có ý định truy cập trái phép vào
                các phần đó hoặc bất kỳ thông tin được bảo vệ nào khác trên Nền tảng DROPNOXE và/hoặc Dịch vụ này, thông
                qua bất kỳ phương tiện nào mà DROPNOXE không cho phép.
              </p>

              <p class="mb-4">
                Nếu bạn dưới 18 tuổi, bạn phải có được sự đồng ý của cha mẹ hoặc người giám hộ hợp pháp, sự chấp thuận
                của họ đối với các Điều khoản sử dụng này và sự đồng ý chịu trách nhiệm của họ đối với: (i) hành động
                của bạn; (ii) bất kỳ khoản phí nào liên quan đến việc bạn sử dụng bất kỳ Dịch vụ nào hoặc mua Sản phẩm;
                và (iii) sự chấp thuận và tuân thủ của bạn đối với các Điều khoản sử dụng này. Nếu bạn không có sự đồng
                ý của cha mẹ hoặc người giám hộ hợp pháp và/hoặc truy cập Nền tảng Dropnoxe này và/hoặc sử dụng Dịch vụ
                và/hoặc mua Sản phẩm mà không có sự giám sát của cha mẹ hoặc người giám hộ hợp pháp, bạn phải dừng các
                hành động này ngay lập tức.
              </p>

              <h2 class="mt-6 mb-3">CÁC NGUYÊN TẮC CHUNG</h2>
              <p class="mb-4">
                DROPNOXE là nền tảng thương mại điện tử xuyên biên giới có lợi nhuận cao với chi phí thấp dành cho người
                bán hàng Dropshipping và Print-on-demand.
              </p>

              <p class="mb-4">
                Trong hợp đồng này, BẠN và DROPNOXE được gọi chung là
                <strong>"Các bên"</strong> và gọi riêng rẽ là <strong>"BÊN"</strong>.
              </p>

              <p class="mb-4">Xét rằng:</p>

              <p class="mb-4">
                BẠN là một cá nhân có đầy đủ năng lực trách nhiệm pháp lý, mong muốn thiết lập cửa hàng trực tuyến để
                kinh doanh các sản phẩm vật lý tới các thị trường trên toàn cầu.
              </p>

              <p class="mb-4">
                DROPNOXE là một công ty chuyên về lĩnh vực thương mại điện tử (E-commerce) với nhiều sản phẩm vật lý đa
                dạng, sẵn sàng cung ứng cho các khách hàng khi có yêu cầu.
              </p>

              <p class="mb-4">
                BẠN mong muốn lựa chọn DROPNOXE là đơn vị cung cấp các dịch vụ cho BẠN. DROPNOXE đồng ý với sự chỉ định
                này.
              </p>

              <p class="mb-4">
                VÌ VẬY, NAY, trên cơ sở những căn cứ nêu trên và các nghĩa vụ chung mà các bên đã thỏa thuận và cam kết
                thực hiện, BẠN đồng ý với các thỏa thuận và nguyên tắc chung với các điều khoản như sau:
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 1 – PHẠM VI HỢP ĐỒNG</h2>
              <p class="mb-4">DROPNOXE cung cấp cho BẠN các dịch vụ sau đây:</p>

              <p class="mb-3">
                <strong>1.1 Thiết lập nền tảng bán hàng:</strong> BẠN sử dụng các hình ảnh, thông tin, sản phẩm, tài
                nguyên do mình tự lựa chọn để tạo tài khoản sử dụng cho một hoặc nhiều cửa hàng trực tuyến thông qua các
                công cụ của nền tảng bán hàng &lt;Dropnoxe.com&gt;. Cửa hàng này do BẠN sở hữu và sử dụng.
              </p>

              <p class="mb-3">
                <strong>1.2 Thiết lập cổng thanh toán:</strong> DROPNOXE xây dựng, phát triển và tích hợp cho BẠN các
                cổng thanh toán. BẠN sử dụng các cổng thanh toán này để nhận tiền thanh toán mua hàng từ các khách hàng
                nước ngoài.
              </p>

              <p class="mb-4">
                <strong>1.3 Thiết lập các công cụ hỗ trợ bán hàng khác:</strong> DROPNOXE xây dựng, phát triển và tích
                hợp cho BẠN các công cụ hỗ trợ bán hàng khác theo yêu cầu của BẠN, bao gồm, nhưng không bị giới hạn bởi:
                công cụ quảng cáo, quản lý đơn hàng, chăm sóc khách hàng…. BẠN sử dụng các công cụ tích hợp này để thúc
                đẩy việc bán hàng tới các khách hàng nước ngoài.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 2 – THỜI HẠN HỢP ĐỒNG</h2>
              <p class="mb-4">
                Thời hạn của hợp đồng được bắt đầu tính từ Ngày ký và, trừ khi bị chấm dứt trước thời hạn quy định trong
                hợp đồng này, thời hạn của hợp đồng sẽ tiếp tục có hiệu lực.
              </p>

              <h2 class="mt-6 mb-3">
                ĐIỀU 3 – GIÁ DỊCH VỤ VÀ PHƯƠNG THỨC THANH TOÁN
              </h2>
              <p class="mb-4">
                Giá dịch vụ và phương thức thanh toán sẽ được thông báo tới BẠN. Việc BẠN lựa chọn tiếp tục sử dụng tài
                khoản và Dịch vụ của DROPNOXE đồng nghĩa với việc BẠN mặc nhiên đồng ý với giá dịch vụ cũng như các thay
                đổi về giá dịch vụ mà DROPNOXE thông báo tới BẠN.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 4 - CAM KẾT CỦA BẠN</h2>

              <h3 class="mt-4 mb-2">Về nội dung nền tảng</h3>
              <p class="mb-2">
                4.1 Tuân thủ quy định pháp luật của tất cả các quốc gia mà BẠN kinh doanh.
              </p>

              <p class="mb-2">
                4.2 Tất cả các nguyên liệu sử dụng, bao gồm, nhưng không bị giới hạn bởi: sản phẩm, hình ảnh, nội dung,
                văn bản,… không xâm phạm quyền lợi của bên thứ ba, bao gồm cả Quyền Sở Hữu Trí Tuệ; hợp pháp, không giả
                mạo, và không vi phạm luật cũng như các quy định liên quan.
              </p>

              <p class="mb-4">
                4.3 Tất cả các thông tin cung cấp cho DROPNOXE là chính xác, có thật và chịu hoàn toàn trách nhiệm trước
                pháp luật về các thông tin này.
              </p>

              <h3 class="mt-4 mb-2">Về cổng thanh toán</h3>
              <p class="mb-2">
                4.4 Tại bất kỳ thời điểm và hoàn cảnh nào, nếu DROPNOXE hoặc bất kỳ bên thứ ba nào phát hiện BẠN vi phạm
                chính sách của cổng thanh toán và/hoặc vi phạm các cam kết đã nêu trong Hợp đồng này, thì BẠN đồng ý
                rằng:
              </p>
              <ul class="mb-3 ml-4">
                <li>
                  a. DROPNOXE, với toàn quyền quyết định của mình, ngay lập tức tạm dừng và/hoặc chấm dứt hoạt động đối
                  với cổng thanh toán của BẠN.
                </li>
                <li>
                  b. BẠN sẽ chịu mọi trách nhiệm liên quan đến hành vi vi phạm, bao gồm cả việc chi trả mọi khoản phí,
                  bồi thường thiệt hại và các biện pháp khắc phục hậu quả.
                </li>
                <li>
                  c. Hành vi vi phạm sẽ được coi là "do BẠN đơn phương thực hiện", do đó, BẠN sẽ miễn trừ mọi trách
                  nhiệm của DROPNOXE đối với các hành vi vi phạm.
                </li>
              </ul>

              <p class="mb-2">
                4.5 BẠN chịu hoàn toàn trách nhiệm đối với tình trạng và số tiền nhận về đối với các cổng thanh toán mà
                BẠN được bàn giao quản lý và sử dụng, bao gồm, nhưng không bị giới hạn bởi:
              </p>
              <ul class="mb-4 ml-4">
                <li>
                  a. Đảm bảo cổng thanh toán luôn trong tình trạng hoạt động tốt, không bị tạm dừng vì bất kỳ lý do vi
                  phạm nào phát sinh.
                </li>
                <li>
                  b. Trong vòng 05 ngày làm việc kể từ ngày cổng thanh toán gặp vấn đề tạm dừng hoạt động và/hoặc mất
                  tiền, BẠN phải thanh toán toàn bộ số tiền không khả dụng cho DROPNOXE nếu nguyên nhân tạm dừng cổng
                  thanh toán là do việc sử dụng vi phạm chính sách của cổng thanh toán hoặc vi phạm quy định của pháp
                  luật của bất kỳ quốc gia nào.
                </li>
                <li>
                  c. Chịu trách nhiệm thanh toán toàn bộ các chi phí cần thiết để DROPNOXE khôi phục lại tình trạng hoạt
                  động bình thường của cổng thanh toán.
                </li>
              </ul>

              <h3 class="mt-4 mb-2">Miễn trừ trách nhiệm cho DROPNOXE</h3>
              <p class="mb-2">
                4.6 BẠN chấp nhận rằng DROPNOXE sẽ không chịu bất kỳ trách nhiệm nào liên quan đến bất kỳ vấn đề nào
                phát sinh từ phía đơn vị đối tác trong bất kỳ trường hợp, hoàn cảnh nào. Nếu có vấn đề phát sinh, Các
                Bên sẽ phối hợp với nhau để giải quyết cùng với các đối tác, mà không truy cứu trách nhiệm của DROPNOXE.
              </p>

              <p class="mb-4">
                4.7 BẠN chấp nhận rằng
                <strong>
                  DROPNOXE chỉ cung cấp dịch vụ nền tảng và không chịu bất kỳ trách nhiệm nào liên quan đến hoạt động
                  quảng cáo do BẠN hoặc đối tác của BẠN thực hiện trên bất kỳ nền tảng nào.</strong
                >
                DROPNOXE không kiểm soát và không chịu trách nhiệm về nội dung, kết quả, chi phí, vi phạm chính sách
                hoặc thiệt hại phát sinh từ việc chạy quảng cáo của BẠN.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 5 - CAM KẾT CỦA DROPNOXE</h2>
              <p class="mb-2">
                5.1 DROPNOXE sẽ nỗ lực hết sức để thực hiện dịch vụ với năng lực tốt nhất có thể. Trong quá trình thực
                hiện dịch vụ, DROPNOXE có thể phối hợp với các đối tác cung cấp dịch vụ bổ trợ để chất lượng dịch vụ của
                DROPNOXE cung cấp là tốt nhất. BẠN hoàn toàn đồng ý với sự can thiệp của các đối tác này.
              </p>

              <p class="mb-2">
                5.2 DROPNOXE sẽ tuân thủ và bám sát các tiêu chuẩn vận hành tốt nhất, bao gồm cả các tiêu chuẩn do BẠN
                quy định trong từng thời điểm khác nhau.
              </p>

              <p class="mb-2">
                5.3 DROPNOXE sẽ tuân thủ và đảm bảo các đối tác do DROPNOXE chỉ định tuân thủ các luật, quy tắc, quy
                định và/hoặc hướng dẫn liên quan đến việc sản xuất, sử dụng, bảo quản, xử lý, vận chuyển, phân phối,
                bán, chuyển giao và/hoặc tiêu hủy vi phạm theo Hợp đồng.
              </p>

              <p class="mb-2">
                5.4 Việc xâm phạm đến quyền của bên thứ ba, bao gồm cả Quyền Sở Hữu Trí Tuệ và/hoặc vi phạm các luật và
                quy định, bao gồm cả việc cung cấp các sản phẩm giả mạo, trái phép bị nghiêm cấm.
              </p>

              <p class="mb-4">
                5.5 Để chủ động ngăn chặn vi phạm, DROPNOXE sẽ nỗ lực và bằng nguồn lực của mình để theo dõi hoạt động
                sử dụng dịch vụ của BẠN để có thể ngay lập tức ngừng, chấm dứt vi phạm. Tuy nhiên, vì DROPNOXE không
                phải là công ty luật hay đơn vị tư vấn pháp lý, DROPNOXE có thể sẽ không có đủ kiến thức trong việc phát
                hiện và xác định các hành vi vi phạm và xâm phạm trên quy mô lớn, do đó, DROPNOXE sẽ không chịu bất kỳ
                trách nhiệm nào nếu có bất kỳ dấu hiệu vi phạm nào được phát hiện trong quá trình cung cấp dịch vụ.
                Trong các trường hợp đó, BẠN phải chịu tất cả trách nhiệm theo như cam kết và miễn trừ toàn bộ trách
                nhiệm cho DROPNOXE.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 6 - CAM ĐOAN VÀ BẢO ĐẢM</h2>
              <p class="mb-2">
                6.1 DROPNOXE có đủ khả năng và thẩm quyền để thực hiện và chuyển giao hợp đồng này và có đầy đủ khả năng
                và thẩm quyền để thực hiện các nghĩa vụ của DROPNOXE đã được nêu trong hợp đồng.
              </p>

              <p class="mb-2">
                6.2 Việc giao kết hợp đồng này sẽ không vi phạm bất kỳ điều khoản và quy định của bất kỳ hợp đồng nào,
                dù dưới dạng văn bản hay lời nói, mà DROPNOXE là một bên.
              </p>

              <p class="mb-2">
                6.3 Việc thực hiện và bàn giao hợp đồng này thuộc trách nhiệm của DROPNOXE và khi Hợp đồng này được ký
                kết và bàn giao bởi DROPNOXE sẽ được coi là cấu thành nghĩa vụ pháp lý cho các bên và có hiệu lực theo
                các điều khoản của Hợp đồng này.
              </p>

              <p class="mb-4">
                6.4 Việc thực hiện các nghĩa vụ của DROPNOXE sẽ được tiến hành tuân thủ với quy định của pháp luật hiện
                hành.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 7 - TÀI SẢN TRÍ TUỆ</h2>
              <p class="mb-2">
                7.1 BẠN cho phép DROPNOXE, vì mục đích thực hiện quyền và nghĩa vụ theo quy định của Hợp đồng được sử
                dụng bất kỳ tài sản trí tuệ nào thuộc sở hữu của BẠN hoặc BẠN có quyền chuyển giao quyền sử dụng.
              </p>

              <p class="mb-2">
                7.2 BẠN không sử dụng các tài sản trí tuệ của DROPNOXE cho các mục đích mà chưa được sự đồng ý của
                DROPNOXE.
              </p>

              <p class="mb-2">
                7.3 DROPNOXE không có bất kỳ quyền nào đối với các tài sản trí tuệ của BẠN, và DROPNOXE không được sử
                dụng các tài sản trí tuệ vào bất kỳ mục đích nào khác ngoài phạm vi và các mục đích khác được quy định
                trong hợp đồng.
              </p>

              <p class="mb-4">
                7.4 DROPNOXE phải thông báo một cách nhanh chóng và đầy đủ cho BẠN biết về bất kỳ hành vi thực tế hoặc
                nguy cơ nào mà DROPNOXE cho rằng đang xảy ra hoặc có thể xảy ra xâm phạm đến tài sản trí tuệ.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 8: CHẤM DỨT HỢP ĐỒNG</h2>
              <p class="mb-2">
                8.1 Bất kể có bất kỳ điều khoản nào khác được quy định trong hợp đồng này, các bên đồng ý rằng hợp đồng
                sẽ tự động chấm dứt hiệu lực mà không cần thông báo cho bên có lỗi hoặc đề ra các giải pháp khắc phục,
                nếu xảy ra các sự kiện sau:
              </p>
              <ul class="mb-3 ml-4">
                <li>
                  a. Nếu quy định của Chính phủ hoặc Phán quyết của Tòa án tại bất kỳ hệ thống pháp luật nào ảnh hưởng
                  nghiêm trọng và bất lợi đến khả năng thực hiện nghĩa vụ được hợp đồng quy định của một bên đối với bên
                  còn lại, được ban hành hoặc có hiệu lực gây bất lợi cho bên đó;
                </li>
                <li>
                  b. Bất kỳ bên nào chuyển nhượng hoặc cố gắng chuyển nhượng hợp đồng này hoặc bất kỳ quyền hoặc nghĩa
                  vụ mà không có sự đồng ý trước bằng văn bản của bên còn lại.
                </li>
              </ul>

              <p class="mb-2">
                8.2 Hợp đồng này còn có thể chấm dứt bởi bất kỳ bên nào tại bất kỳ thời điểm nào nếu bên còn lại vi phạm
                đáng kể bất kỳ điều khoản nào của hợp đồng và bên đó không thể đưa ra phương án khắc phục trong vòng
                mười (10) ngày kể từ khi nhận được thông báo bằng văn bản nêu rõ vi phạm từ bên bị vi phạm.
              </p>

              <p class="mb-2">
                8.3 Việc chấm dứt hợp đồng theo những quy định nêu trên không loại trừ trách nhiệm của bất kỳ bên nào
                đối với những nghĩa vụ phát sinh trước thời điểm chấm dứt.
              </p>

              <p class="mb-2">8.4 Hệ quả của việc chấm dứt hợp đồng:</p>
              <ul class="mb-3 ml-4">
                <li>
                  a. DROPNOXE hoàn trả BẠN toàn bộ thông tin bí mật, quyền sử dụng các tài sản trí tuệ và bất kỳ tài
                  liệu hoặc thư mục được giao cho DROPNOXE và liên quan đến Hợp đồng liên quan đến Hợp đồng hoặc hoạt
                  động kinh doanh của BẠN.
                </li>
                <li>
                  b. DROPNOXE chấm dứt việc sử dụng các tài sản trí tuệ của BẠN và không tự mình tuyên bố vai trò là nhà
                  cung cấp dịch vụ của BẠN.
                </li>
                <li>
                  c. DROPNOXE chấm dứt việc sử dụng của bất kỳ tài khoản nào của BẠN trên nền tảng của DROPNOXE.
                </li>
              </ul>

              <p class="mb-4">8.5 Chấm dứt hợp đồng do vi phạm quyền sở hữu trí tuệ:</p>
              <ul class="mb-4 ml-4">
                <li>
                  a. DROPNOXE chấm dứt Hợp Đồng mà không bị BẠN phản đối hoặc khiếu nại.
                </li>
                <li>
                  b. DROPNOXE tiêu hủy tất cả các yếu tố vi phạm với các chi phí phát sinh do BẠN chi trả trong vòng ba
                  (03) ngày kể từ ngày tiêu hủy xong các sản phẩm vi phạm.
                </li>
              </ul>

              <h2 class="mt-6 mb-3">
                ĐIỀU 9 - GIỚI HẠN TRÁCH NHIỆM VÀ MIỄN TRỪ
              </h2>
              <p class="mb-4">
                Một bên đồng ý bảo đảm và miễn trừ cho bên còn lại trước các trách nhiệm pháp lý, mất mát, thiệt hại
                hoặc chi phí nào (bao gồm cả chi phí pháp lý) phải gánh chịu do hành vi vi phạm, hành vi vô ý do cẩu thả
                hoặc cố ý gián tiếp gây thiệt hại của bên đó, hoặc người đại diện của bên đó phát sinh trực tiếp hoặc
                gián tiếp từ quá trình thực hiện hợp đồng của bên đó hoặc bất kỳ đại diện nào của bên đó trong việc thực
                hiện bất kỳ nghĩa vụ nào.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 10 - SỰ KIỆN BẤT KHẢ KHÁNG</h2>
              <p class="mb-2">
                10.1 Sự vi phạm của BẠN và DROPNOXE trong việc thực hiện nghĩa vụ theo quy định của Hợp đồng sẽ không bị
                coi là vi phạm hợp đồng hoặc tạo ra bất kỳ trách nhiệm pháp lý nào nếu xảy ra sự kiện bất khả kháng, bao
                gồm cả các sự kiện nằm ngoài sự kiểm soát của BẠN và DROPNOXE, những sự kiện này bao gồm (nhưng không
                giới hạn) các sự kiện như: Sự kiện tự nhiên nghiêm trọng, không lường trước được; chính sách của Chính
                phủ hoặc các cơ quan nhà nước; phiến loạn; khởi nghĩa; tụ tập phá rối, phá hoại nhà nước, chiến tranh
                xâm lược, cách ly, giới nghiêm, đình công, phong tỏa và lệnh cấm vận, với điều kiện các bên dựa vào điều
                khoản này phải thông báo bằng văn bản cho bên còn lại biết về tình trạng không thể thực hiện nghĩa vụ và
                nguyên nhân dẫn tới tình trạng đó ngay khi các sự kiện này xảy ra.
              </p>

              <p class="mb-4">
                10.2 Nếu sự kiện bất khả kháng tiếp tục kéo dài thêm ba (03) tháng, nếu các bên không thể sắp xếp một
                giải pháp thay thế thỏa đáng thì có thể lựa chọn việc chấm dứt hợp đồng.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 11 - ĐIỀU KHOẢN BẢO MẬT</h2>
              <v-alert color="error" outlined class="mb-4">
                <strong>11.1</strong> Mỗi bên phải coi các thông tin nhận được, dù dưới dạng văn bản hay bằng miệng được
                bộc lộ bởi bên còn lại là các thông tin bảo mật, và không được tiết lộ những thông tin này với bên thứ
                ba khi chưa có sự cho phép bằng văn bản của bên còn lại. Trong trường hợp vi phạm, bên vi phạm sẽ phải
                trả, theo yêu cầu đầu tiên của bên còn lại, ít nhất
                <strong>100.000.000VNĐ (Một trăm triệu đồng)</strong>. Khoản tiền này sẽ không tước bỏ của bên bị vi
                phạm quyền khởi kiện đòi bồi thường thiệt hại nếu thiệt hại thực tế cho bên bị vi phạm lớn hơn khoản bồi
                thường nêu trên. Nghĩa vụ bảo mật này sẽ có hiệu lực với các bên trong vòng
                <strong>năm (05) năm</strong>. DROPNOXE không phải chịu trách nhiệm nếu bộc lộ bất kỳ thông tin nào mà
                bắt buộc phải bộc lộ theo quy định của luật hoặc bất kỳ quy chế nào khác.
              </v-alert>

              <p class="mb-4">
                11.2 Mỗi bên phải đảm bảo rằng giám đốc, nhân viên, các đại lý hoặc các đơn vị trung gian tuân thủ nghĩa
                vụ.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 12 - LUẬT ÁP DỤNG</h2>
              <p class="mb-2">
                12.1 Thỏa thuận này và mọi tranh chấp, tranh cãi, thủ tục tố tụng hoặc khiếu nại thuộc bất kỳ tính chất
                nào phát sinh từ hoặc liên quan đến Thỏa thuận này hoặc việc hình thành Thỏa thuận này theo bất kỳ cách
                nào sẽ được điều chỉnh và giải thích theo luật pháp Việt Nam.
              </p>

              <p class="mb-4">
                12.2 Tranh chấp sẽ được ưu tiên giải quyết bằng thương lượng. Nếu không thể giải quyết tranh chấp bằng
                thương lượng, các bên giải quyết theo thủ tục tố tụng tại Tòa án có thẩm quyền theo quy định hiện hành.
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 13 - THƯ TÍN</h2>
              <p class="mb-4">
                Mọi thông tin trao đổi chính thức giữa Các Bên đều phải được thực hiện bằng văn bản tới email liên hệ
                (là email BẠN sử dụng để thiết lập tài khoản sử dụng).
              </p>

              <h2 class="mt-6 mb-3">ĐIỀU 14- CÁC ĐIỀU KHOẢN KHÁC</h2>
              <p class="mb-2">
                14.1 Trừ khi có quy định khác, hợp đồng này không bị sửa đổi hoặc điều chỉnh trừ khi được thực hiện bằng
                văn bản có chữ ký của cả hai bên
              </p>

              <p class="mb-2">
                14.2 Hợp đồng này, bao gồm cả các Phụ lục đính kèm, tạo thành một thỏa thuận chung giữa các bên với tất
                cả các điều khoản nêu trong hợp đồng này và thay thế mọi thỏa thuận bằng lời nói hoặc thỏa thuận bằng
                văn bản trước đó.
              </p>

              <p class="mb-2">
                14.3 Các từ "ở đây", "ở đây", "dưới đây" và các cách diễn đạt tương tự được sử dụng trong bất kỳ phần
                nào của Hợp đồng này liên quan đến toàn bộ Hợp đồng này (bao gồm bất kỳ Phụ lục nào kèm theo) và không
                chỉ cho phần đó, trừ khi được quy định rõ ràng chỉ ra điều ngược lại. Các từ chỉ nhập số ít sẽ bao gồm
                số nhiều và ngược lại và các từ chỉ nhập giới tính nam sẽ bao gồm giới tính nữ và giới tính ngoài và
                ngược lại. Từ "bao gồm" sẽ có nghĩa là "bao gồm nhưng không giới hạn".
              </p>

              <p class="mb-2">
                14.4 Một bên không thể chỉ định hoặc chuyển giao quyền và nghĩa vụ của bên đó theo quy định của hợp đồng
                hoặc bất cứ tài liệu nào liên quan đến hợp đồng cho người khác mà chưa được sự đồng ý bằng văn bản của
                bên còn lại. Hợp đồng này có hiệu lực ràng buộc vì lợi ích của các bên và những người nhận quyền và
                người được nhận chuyển giao nghĩa vụ có sự chấp thuận của bên còn lại.
              </p>

              <p class="mb-2">
                14.5 Việc một bên không yêu cầu bên còn lại thực hiện bất kỳ điều khoản nào của hợp đồng này vào thời
                điểm bất kỳ sẽ không ảnh hưởng đến quyền yêu cầu của họ sau đó, và không một quy định hoặc điều khoản
                nào của hợp đồng được miễn trừ và không có bất cứ vi phạm nào được miễn, trừ khi có văn bản đồng ý có
                chữ kí của bên đồng ý miễn trừ.
              </p>

              <p class="mb-2">14.6 Thời gian sẽ là điều tiên quyết của Hợp đồng này.</p>

              <p class="mb-2">
                14.7 Nếu bất kỳ điều khoản nào của Thỏa thuận này, ở bất kỳ mức độ nào, được coi là không hợp lệ hoặc
                không thể thi hành, nó sẽ được coi là tách biệt và có thể tách rời khỏi các điều khoản còn lại của Thỏa
                thuận này. Hợp đồng sẽ vẫn có đầy đủ hiệu lực và ràng buộc kể cả khi điều khoản không hợp lệ hoặc không
                thể thực thi đã không được bao gồm.
              </p>

              <p class="mb-4">
                14.8 Hợp đồng này được thể hiện bằng văn bản, thể hiện ý chí tự nguyện giao kết của các bên.
              </p>
            </div>
          </v-card>
        </div>
        <div class="pa-4" style="border-radius: 8px;">
          <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center;">
            <v-checkbox
              v-model="termsAgreed"
              label="Tôi xác nhận đã đọc, hiểu, và đồng ý với tất cả các nội dung
                    nêu trong bản 'Điều khoản sử dụng' này. Tôi đồng ý tạo một tài khoản mới để sử dụng các Dịch vụ của
                    DROPNOXE."
              hide-details
            ></v-checkbox>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12" md="12" sm="12" class="d-flex mb-3 justify-space-between">
      <v-btn @click="$parent.$parent.$parent.e1 = 1" class="ml-1">Back</v-btn>

      <div class="d-flex">
        <v-btn class="mr-2" :loading="isLoading" :disabled="!termsAgreed" @click="submit">Next</v-btn>
        <!-- <v-btn class="ml-auto" :loading="isLoading" @click="submit" color="primary" :disabled="!importFromStore.storeId"
          >Import
        </v-btn> -->
      </div>
    </v-col>
  </div>
</template>

<script>
import { authService } from '@/apis/auth.s';
import Api from '@/apis/';
import { required, minLength, maxLength, email, helpers, decimal } from 'vuelidate/lib/validators';
import axios from 'axios';
import { userService } from '@/apis/user.s';

export default {
  props: {
    /**
     * Callback
     */
    callback: {
      type: Function,
      default(data) {},
    },
    store: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      importFromStore: {
        storeId: '',
        doNotImport: false,
        importItems: {
          themesChecked: true,
          collectionChecked: true,
          navigationChecked: true,
          pagesChecked: true,
          appsChecked: true,
          legalPagesChecked: true,
          shippingCurrencyChecked: true,
          productsChecked: true,
        },
      },
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      showNext: false,
      mmoExperiences: [
        {
          name: `I'm a newbie and have no experience in selling online`,
          value: `I'm a newbie and have no experience in selling online`,
        },
        {
          name: `I have experience in selling on other eCommerce platforms (Shopify, Woocommerce...)`,
          value: `I have experience in selling on other eCommerce platforms (Shopify, Woocommerce...)`,
        },
        {
          name: `I have experience in selling on eCommerce marketplaces (Amazon/Ebay/...)`,
          value: `I have experience in selling on eCommerce marketplaces (Amazon/Ebay/...)`,
        },
        {
          name: `I want to scale my business with the current revenue of over $500k/month`,
          value: `I want to scale my business with the current revenue of over $500k/month`,
        },
      ],
      mmoExperience: `I'm a newbie and have no experience in selling online`,
      primaryColor: '#FFD642',
      showMenu: false,
      font: 'Abel',
      fonts: [],
      isLoading: false,
      invalid: false,
      stores: [],
      termsAgreed: true,
    };
  },
  validations: {
    font: {
      required,
    },
    mmoExperience: {
      required,
    },
  },
  async created() {
    this.getWebFonts();
    await this.getStores();
  },
  methods: {
    async getWebFonts() {
      let api = new Api();
      // let data = await api.get(
      //   'https:/cors-anywhere.herokuapp.com/https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyA3ojYhGFCJnCL8Q45gkEGjXfPd3tBMUAQ',
      // );
      axios
        .get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyA3ojYhGFCJnCL8Q45gkEGjXfPd3tBMUAQ')
        .then(response => {
          this.fonts = response.data.items;
        })
        .catch(error => {
          console.log('error', error);
        });
    },
    selectFont() {},
    next() {
      this.isLoading = true;
      this.$v.$touch();
      this.invalid = this.$v.$invalid;
      if (!this.invalid) {
        this.showNext = true;
        this.isLoading = false;
      }
    },
    async getStores() {
      var vm = this;
      try {
        let data = await userService.getStores();
        this.stores = data.data
          .reverse()
          .filter(store => store !== null && store.id != vm.$route?.query?.storeId)
          .map(item => {
            return {
              ...item,
              name: item.storeDetail.name,
            };
          });
        this.stores.unshift({ id: null, name: 'Select store' });
      } catch (error) {
        console.log(error.response);
      }
    },
    submit() {
      if (!this.$v.$invalid) {
        this.callback({
          color: this.primaryColor,
          font: this.font,
          mmoExperience: this.mmoExperience,
          importFromStore: this.importFromStore,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.input-picker-color {
  width: 100%;
  @include flex();
  border-radius: 8px;
  position: relative;

  .btn-color {
    position: absolute;
    right: 10px;
  }

  background: #f5f6f7 !important;

  .v-input__slot {
    border-radius: 0 !important;
  }

  .text-field-color {
    .v-input__slot {
      border-radius: 0 !important;
    }
  }
}

.iphone {
  position: relative;
  background: #202020;
  width: 360px;
  height: 700px;
  padding-top: 95%;
  margin: 0 auto;
  border-radius: 3em;
}

.power {
  position: absolute;
  background: #202020;
  width: 13%;
  height: 0.5%;
  top: -0.5%;
  right: 21%;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
}

.lock {
  position: absolute;
  background: #202020;
  width: 1%;
  height: 5%;
  top: 12.5%;
  left: -1%;
  border-top-left-radius: 0.5em;
  border-bottom-left-radius: 0.5em;
}

.volume {
  position: absolute;
  background: #202020;
  width: 1%;
  height: 4%;
  top: 23%;
  left: -1%;
  border-top-left-radius: 0.5em;
  border-bottom-left-radius: 0.5em;
}

.volume.down {
  top: 31%;
}

.camera {
  position: absolute;
  top: 4%;
  left: 48.5%;
  background: #3f3f3f;
  width: 3%;
  height: 0;
  padding-top: 3%;
  border-radius: 50%;
}

.speaker {
  position: absolute;
  top: 7%;
  left: 42.5%;
  background: #3f3f3f;
  width: 15%;
  height: 0;
  padding-top: 3%;
  border-radius: 1em;
}

.appleicon {
  padding-top: 25%;
  opacity: 0;
  animation: unhide 5s infinite alternate;
}

.appleicon img {
  width: 100%;
  height: 100%;
}

.text {
  opacity: 0;
  font-size: 1.25rem;
  text-align: center;
  animation: unhide 5s infinite alternate;
}

.screen {
  background: #2f2f2f;
  width: 90%;
  height: 75%;
  position: absolute;
  top: 12.5%;
  left: 5%;
  animation: lighten 5s infinite alternate;
}

.button {
  position: absolute;
  bottom: 2.75%;
  left: 42.5%;
  background: #3f3f3f;
  /* border: 1px solid #3f3f3f; */
  width: 15%;
  height: 0;
  padding-top: 15%;
  border-radius: 50%;
}

.square {
  position: absolute;
  top: 27.5%;
  left: 27.5%;
  border: 2px solid #d7d7d7;
  border-radius: 0.3em;
  width: 45%;
  height: 45%;
}

@media screen and (min-width: 28em) {
  body {
    font-size: 8px;
  }
}

@media screen and (min-width: 34em) {
  body {
    font-size: 10px;
  }
}

@media screen and (min-width: 48em) {
  body {
    font-size: 14px;
  }
}

@keyframes lighten {
  0%,
  45% {
    background: #2f2f2f;
  }
  65%,
  100% {
    background: #f7f7f7;
  }
}

@keyframes unhide {
  0%,
  55% {
    opacity: 0;
  }
  75%,
  100% {
    opacity: 1;
  }
}

/* Terms of Service Styles */
.terms-section {
  margin-top: 24px;
}

.terms-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.terms-content {
  line-height: 1.6;
}

.terms-content p {
  text-align: justify;
  margin-bottom: 16px;
  font-size: 14px;
}

.terms-content strong {
  font-weight: 600;
}

.terms-content h4 {
  font-weight: 600;
  color: #1976d2;
  margin-top: 20px;
  margin-bottom: 12px;
}

.terms-content h5 {
  font-weight: 500;
  color: #424242;
  margin-top: 16px;
  margin-bottom: 8px;
}

.terms-content ul {
  padding-left: 20px;
  margin-bottom: 16px;
}

.terms-content li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.agreement-section {
  background: #f5f5f5;
  border: 2px solid #1976d2;
  border-radius: 8px;
  margin-top: 20px;
}

.terms-scroll-container::-webkit-scrollbar {
  width: 8px;
}

.terms-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.terms-scroll-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.terms-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@media (max-width: 600px) {
  .terms-scroll-container {
    max-height: 300px;
    padding: 15px;
  }

  .terms-content p {
    font-size: 13px;
  }
}
</style>
